import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: '/admin/pledgeMiningCoefficient//findAll',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/pledgeMiningCoefficient/save',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/admin/pledgeMiningCoefficient/update',
      data
    });
  },
  remove(data) {
    return http.get({
      url: '/admin/pledgeMiningCoefficient/deleteById',
      data: {
        id: data
      }
    });
  }
};
